import React from "react";
import { Button } from "flowbite-react";

interface OwnProps {
	color?: "primary" | "secondary";
	title: string;
}

const CTA = ({ color, title }: OwnProps) => {
	const bgColor = color || "primary";
	return (
		<div className="flex justify-center">
			<Button
				href="https://app.deadeasy.life"
				target="_blank"
				className={`bg-${
					color || "primary"
				} hover:bg-orange rounded-full md:px-6 md:py-2 uppercase font-bold text-white dark:text-white`}
				style={{
					backgroundColor: bgColor === "primary" ? "#ec8b34" : "#9bc7e3",
				}}
			>
				{title}
			</Button>
		</div>
	);
};

export default CTA;
